<template>
  <a-modal v-model:visible="visible" title="展会列表" width="60%" v-highlight>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="称号名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入称号名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select placeholder="请选择状态" style="width: 250px" v-model="queryParam.status" allowClear>
                  <a-select-option
                    v-for="(item, index) in this.customDict.ExpoStatusEnum"
                    :value="item.type"
                    :key="index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="startTime" slot-scope="text, record">
          {{ parseTime(record.startTime) }}
        </span>
        <span slot="endTime" slot-scope="text, record">
          {{ parseTime(record.endTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!--          <a-divider type="vertical" v-hasPermi="['expo:expo:edit']" />-->
          <!--          <a-divider type="vertical" v-hasPermi="['expo:expo:remove']" />-->
          <a @click="handleDelete(record)" v-hasPermi="['expo:expo:remove']">
            绑定
          </a>
        </span>
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ExpoStatusEnum" :value="record.status"/>
        </span>
        <div slot="cover" slot-scope="text, record" style="cursor: pointer;">
          <img v-if="record.cover" :src="record.cover" style="height:40px;" preview alt=""/>
        </div>
        <!--        <span slot="cover" slot-scope="text, record">-->
        <!--          <img v-if="record.cover" :src="record.cover" preview style="width:60px;height:62px;" alt=""/>-->
        <!--        </span>-->
        <span slot="banner" slot-scope="text, record">
          <img v-if="record.banner" :src="record.banner" preview style="width:60px;height:62px;" alt=""/>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-modal>
</template>

<script>
import { listExpo, delExpo } from '@/api/expo/expo'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
export default {
  name: 'IndexExpoModal',
  components: {
    CustomDictTag
  },
  mixins: [tableMixin],
  data () {
    return {
      visible: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        cover: null,
        banner: null,
        scriptNum: null,
        city: null,
        startTime: null,
        endTime: null,
        status: undefined,
        browserValue: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /* {
          title: 'id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        }, */
        {
          title: '展会名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '展会封面',
          dataIndex: 'cover',
          ellipsis: true,
          width: 140,
          scopedSlots: { customRender: 'cover' },
          align: 'center'
        },
        /* {
          title: '展会详情',
          dataIndex: 'banner',
          ellipsis: true,
          scopedSlots: { customRender: 'banner' },
          align: 'center'
        }, */
        // {
        //   title: '参展剧本数',
        //   dataIndex: 'scriptNum',
        //   ellipsis: true,
        //   align: 'center'
        // },order/group/detail/get/personinfo
        {
          title: '城市名称',
          dataIndex: 'city',
          ellipsis: true,
          width: 80,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '开始时间',
          dataIndex: 'startTime',
          scopedSlots: { customRender: 'startTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
          scopedSlots: { customRender: 'endTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },

        {
          title: '浏览量',
          dataIndex: 'browserValue',
          ellipsis: true,
          width: 80,
          align: 'center'
        },
        /* {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }, */
       /* {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        }, */
        {
          title: '操作',
          dataIndex: 'operation',
          width: 80,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    /** 查询展会列表 */
    getList () {
      this.loading = true
      listExpo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onDateChange(date, dateString) {
      console.log(date, dateString)
      this.queryParam.startTime = dateString
    },
    onDateChange1(date, dateString) {
      console.log(date, dateString)
      this.queryParam.endTime = dateString
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        cover: undefined,
        banner: undefined,
        scriptNum: undefined,
        city: undefined,
        startTime: undefined,
        endTime: undefined,
        status: undefined,
        browserValue: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      const name = row.name
      console.log('获取到的剧本名称', name)
      console.log('获取到的', ids)
      this.visible = false
      this.$emit('select', ids)
      this.$emit('selectname', name)
      this.$emit('selectAll', row)
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('expo/expo/export', {
            ...that.queryParam
          }, `expo_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    open() {
      this.visible = true
    }
  }
}
</script>
